import api from "core/api/api";

export default {
    wizardType: "MONGODB",

    getJDBCURL: (m) => {
        if (m.get("host").indexOf("mongodb+srv://") === 0) {
            return m.get("host");
        }
        return m.get("host") + ":" + m.get("port");
    },

    getConnectionParams: (type, model) => ({
        UserName: model.get("username"),
        Password: model.get("password"),
        ConnectionURL: model.getJDBCURL(),
    }),

    async checkCDCPermissions(model, agentName) {
        const params = {
            UserName: model.get("username"),
            Password: model.get("password"),
            ConnectionURL: model.getJDBCURL(),
        };
        const cdcResult = await api.WizardHelper_CheckCDCConfigurations("MONGODB", params, agentName);
        model.checkResponse(cdcResult);
        const privResult = await api.WizardHelper_CheckPrivileges("MONGODB", params, agentName);
        model.checkResponse(privResult);
        return true;
    },
};

